import React from 'react';

import './CarouselSkeleton.css';

function CarouselSkeleton() {
  return (
    <div className='CarouselSkeleton'>
      <div className='CarouselSkeleton-header'>
        <div className='CarouselSkeleton-headerTextIconGroup'>
          <div className='CarouselSkeleton-headerIcon CarouselSkeleton-animateSkeleton' />
          <div className='CarouselSkeleton-headerText'>
            <div className='CarouselSkeleton-headerTitle CarouselSkeleton-animateSkeleton' />
            <div className='CarouselSkeleton-headerDescription CarouselSkeleton-animateSkeleton' />
          </div>
        </div>
        <div className='CarouselSkeleton-closeButton CarouselSkeleton-animateSkeleton' />
      </div>
      <div className='CarouselSkeleton-body'>
        <div className='CarouselSkeleton-bodyMennu'>
          <div className='CarouselSkeleton-menuButtons CarouselSkeleton-animateSkeleton' />
          <div className='CarouselSkeleton-menuButtons CarouselSkeleton-animateSkeleton' />
          <div className='CarouselSkeleton-menuButtons CarouselSkeleton-animateSkeleton' />
          <div className='CarouselSkeleton-menuButtons CarouselSkeleton-animateSkeleton' />
        </div>
        <div className='CarouselSkeleton-scoreGroup'>
          <div className='CarouselSkeleton-scoreIcon CarouselSkeleton-animateSkeleton' />
          <div className='CarouselSkeleton-scoreText CarouselSkeleton-animateSkeleton' />
        </div>
        <div className='CarouselSkeleton-bodyText'>
          <div className='CarouselSkeleton-bodyTextLineItem CarouselSkeleton-animateSkeleton' />
          <div className='CarouselSkeleton-bodyTextLineItem CarouselSkeleton-animateSkeleton' />
          <div className='CarouselSkeleton-bodyTextLineItem CarouselSkeleton-animateSkeleton' />
          <div className='CarouselSkeleton-bodyTextLineItem CarouselSkeleton-animateSkeleton' />
          <div className='CarouselSkeleton-bodyTextLineItem CarouselSkeleton-animateSkeleton' />
          <div className='CarouselSkeleton-bodyTextLineItem CarouselSkeleton-animateSkeleton' />
          <div className='CarouselSkeleton-bodyTextLineItem CarouselSkeleton-animateSkeleton' />
          <div className='CarouselSkeleton-bodyTextLineItem CarouselSkeleton-animateSkeleton' />
          <div className='CarouselSkeleton-bodyTextLineItem CarouselSkeleton-animateSkeleton' />
        </div>
      </div>
      <div className='CarouselSkeleton-footer'>
        <div className='CarouselSkeleton-actionButtons CarouselSkeleton-animateSkeleton' />
        <div className='CarouselSkeleton-actionButtons CarouselSkeleton-animateSkeleton' />
        <div className='CarouselSkeleton-actionButtons CarouselSkeleton-animateSkeleton' />
        <div className='CarouselSkeleton-actionButtons CarouselSkeleton-animateSkeleton' />
      </div>
    </div>
  );
}

export default CarouselSkeleton;
